import React from 'react';
import PropTypes from 'prop-types';
import {
  IconAppLauncher,
  IconCancel,
  IconDelivery,
  IconHealth,
  IconStores,
  IconTravels,
  IconUncategorized,
  IconServicePoint,
  IconPhone,
} from '@klarna/bubble-ui';
import { SensitiveGoodCategory } from '@mjolnir/mf-fields-ts/src/enm/SensitiveGoodCategory';
import { ProductChannel } from '@mjolnir/mf-fields-ts/src/enm/ProductChannel';

export const CardsSelectorIconComponent = id =>
  ({
    CBD_HEMP_TOBACCO_ECIGARETTES_VAPE: IconCancel,
    EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS: IconTravels,
    WEAPONS_AMMUNITION: IconAppLauncher,
    PHARMACEUTICALS: IconHealth,
    SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT: IconDelivery,
    MARKETPLACE: IconStores,
    NONE: IconUncategorized,
    [SensitiveGoodCategory.AGE_RESTRICTED_PRODUCTS]: IconCancel,
    [SensitiveGoodCategory.LICENSED_WEAPONS]: IconAppLauncher,
    [SensitiveGoodCategory.MEMBERSHIPS_SUBSCRIPTIONS_SERVICES]: IconDelivery,
    [SensitiveGoodCategory.NONE]: IconUncategorized,
    [SensitiveGoodCategory.PEER_TO_PEER_MARKETPLACE]: IconStores,
    [SensitiveGoodCategory.PHARMA_AND_MEDICAL_SERVICES]: IconHealth,
    [SensitiveGoodCategory.TRAVEL_TOURS_EVENTS]: IconTravels,
    [ProductChannel.IN_STORE]: IconServicePoint,
    [ProductChannel.TELESALES]: IconPhone,
  }[id] || IconUncategorized);

export const CardsSelectorIcon = ({ id }) => {
  const Component = CardsSelectorIconComponent(id);
  return <Component />;
};

CardsSelectorIcon.propTypes = {
  id: PropTypes.string.isRequired,
};
